export enum PeAssetState {
  Active = 1,
  Archived = 2,
}

export const isValidPeAssetState = (num: number): boolean => {
  return Object.values(PeAssetState).includes(num);
};
